import { useEffect, useState } from 'react';
import { useCases } from '../../infrastructure/di/container';

export const useAdvertTelegramAccounts = (advertUUID: string | undefined, enabled: boolean) => {
  const [telegramAccountUUIDs, setTelegramAccountUUIDs] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!advertUUID || !enabled) return;
    let cancelled = false;
    setLoading(true);
    setError(undefined);
    useCases.getAdvertTelegramAccounts().execute(advertUUID)
      .then(uuids => { if (!cancelled) setTelegramAccountUUIDs(uuids); })
      .catch((e: any) => { if (!cancelled) setError(e?.message || 'advert-telegram-accounts-load-failed'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [advertUUID, enabled]);

  return { telegramAccountUUIDs, loading, error };
};
